import React, { useContext, useEffect, useState } from 'react';
import {
  Col,
  Row,
  Card,
  Divider,
  Typography,
  message,
  AutoComplete,
  Input,
  Spin,
  Dropdown,
  Result,
  ConfigProvider,
  Pagination,
  Layout,
  Button,
} from 'antd';

import {
  MoreOutlined,
  PlusOutlined,
  RiseOutlined,
  UserOutlined,
  ReloadOutlined,
  DownOutlined,
  UploadOutlined,
  ExportOutlined,
  FilterOutlined,
  SortAscendingOutlined,
  SearchOutlined,
} from '@ant-design/icons';

import {
  getDownloadTemplate,
  getSearch,
  getTranscationData,
  getTranscations,
  updateTransactionStatus,
} from "../../../services/TransactionApi's";

import './Transactions.css';
import { isEmpty } from '../../../utils/helpers/helper';
import CustomButton from '../../common/Button/Button';
import UploadFile from '../../common/Upload/UploadFile';
import {
  CREATE_NEW_TRANSACTION,
  LOCK_MSG,
  UPLOAD_TRANS_BATCH_UPDATES,
} from '../../../constants/ApiConstants';
import TransactionsTable from './TransactionTable';
import colors from '../../../constants/ColourConstants';
import FiltersPane from './FiltersPane';
import CreateInvoiceModal from './Modals/CreateInvoiceModal';
import UpdateTransactionModal from './Modals/UpdateTransactionModal';
import { createInvoice } from '../../../services/InvoiceAPIs';
import AsyncTasksModal from '../BatchProcesses/AsyncTasksModal';
import moment from 'moment';
import { AppFactsContext } from '../../common/Navigation/Navigation';

const { Link } = Typography;

export const initFilters = {
  contributorEmail: '',
  contributorProjectId: '',
  country: [],
  project: '',
  transactionType: '',
  category: [],
  transactionDate: '',
  transactionId: '',
  invoicePeriod: { month: [], year: '' },
  payRate: '',
  amount: '',
  transactionStatus: [],
  lastModifiedDate: '',
  createdDate: 'Last 30 days',
  note: '',
  // sortOrder: 'Newest to oldest',
};

const Transactions = () => {
  const [cardsLoader, setCardsLoader] = useState(true);
  const [transactionData, setTransactionData] = useState({});
  const [cardserror, setCardsError] = useState(false);

  const [tableId, setTableId] = useState(1);
  const [transactions, setTransactions] = useState({});
  const [currentData, setCurrentData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const [pageLoader, setPageLoader] = useState(true);
  const [tableLoader, setTableLoader] = useState(false);
  const [error, setError] = useState(false);

  const [openFilters, setOpenFilters] = useState(false);
  const [filterValues, setFilterValues] = useState(initFilters);
  const [fullScreenLoader, setFullScreenLoader] = useState(false);

  const [searchLoader, setSearchLoader] = useState(false);
  const [searchOptions, setSearchOptions] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [searchValue, setSearchValue] = useState('');
  const [searchDropdown, setSearchDropdown] = useState(false);

  const [messageApi, contextHolder] = message.useMessage();
  const [isAsyncTasksModalOpen, setIsAsyncTasksModalOpen] = useState(false); // State for AsyncTasksModal

  const [uploadModel, setUploadModel] = useState({
    open: false,
    key: 1,
    type: '',
    url: '',
  });
  const [showUpdateTransactionModal, setShowUpdateTransactionModal] =
    useState(false);

  const [showCreateInvoiceModal, setShowCreateInvoiceModal] = useState(false);

  const LOCKED_STATUSES = [
    'Added to Invoice',
    'Added to Payout',
    'Payout Pending',
    'Payout Failure',
    'Payout Completed',
    'Voided',
  ];

  const { appFacts } = useContext(AppFactsContext);

  const [isCreateDisable, setIsCreateDisable] = useState(false);
  const [isUpdateDisable, setIsUpdateDisable] = useState(false);
  const [isCreateInvoiceDisable, setIsCreateInvoiceDisable] = useState(false);

  const [sortField, setSortField] = useState({});
  const fields = {
    transactionId: 'ids',
    payRate: 'payRates',
    transactionAmount: 'amounts',
    createdDate: 'createdDates',
    modifiedDate: 'modifiedDates',
    transactionDate: 'transactionDates',
    hours: 'hour',
    units: 'unit',
  };

  const handlePageChange = (page) => setCurrentPage(page);

  const handlePageSizeChange = (_current, size) => setPageSize(size);

  useEffect(() => {
    const { generate_transactions, update_transactions, generate_invoices } =
      appFacts;
    if (generate_transactions !== undefined) {
      setIsCreateDisable(generate_transactions);
    }

    if (update_transactions !== undefined) {
      setIsUpdateDisable(update_transactions);
    }

    if (generate_invoices !== undefined) {
      setIsCreateInvoiceDisable(generate_invoices);
    }
  }, [
    appFacts?.generate_transactions,
    appFacts?.update_transactions,
    appFacts?.generate_invoices,
  ]);
  useEffect(() => {
    handleCardsApi();
    !pageLoader && handleTransactions();
  }, []);

  useEffect(() => {
    !pageLoader && handleApplyFilters();
  }, [pageSize]);

  useEffect(() => {
    if (transactions[currentPage]) {
      setCurrentData(transactions[currentPage]);
    } else {
      handleTransactions();
    }
  }, [currentPage]);

  useEffect(() => {
    setCurrentData(transactions[currentPage]);
  }, [transactions]);

  useEffect(() => {
    handleTransactions();
  }, [sortField]);

  const handleMessage = (type, content) => {
    messageApi.open({
      type: type,
      content: content,
      duration: 10,
    });
  };

  const handleCardsApi = async () => {
    setCardsLoader(true);
    try {
      const data = await getTranscationData('{data}');
      setTransactionData(data?.data || {});
    } catch (error) {
      setCardsError(true);
      // handleMessage('error', 'Unable to fetch transaction cards data');
    } finally {
      setCardsLoader(false);
    }
  };

  const getStatusType = (status) => {
    return (
      {
        'Contributor Approved': 'default',
        'Pending PM Approval': 'default',
        'Under Further Review': 'default',
        Voided: 'default',

        'Ready for Finance Review': 'cyan',
        'Ready for Invoice': 'cyan',
        'Added to Invoice': 'cyan',
        'Added to Payout': 'cyan',

        'Payout Pending': 'warning',

        'Payout Failure': 'error',

        'Payout Completed': 'success',
      }[status] || 'default'
    );
  };

  const transformData = (jsonData) => {
    const { columns, rows } = jsonData;

    let map = rows.map((row) => {
      return columns.reduce((obj, col, index) => {
        obj[col] = row[index];
        obj['key'] = obj['transactionId'];
        return obj;
      }, {});
    });

    map = map.map((item) => {
      const striked = item.transactionStatus === 'Voided';
      const isLocked = LOCKED_STATUSES.includes(item.transactionStatus);

      return {
        ...item,
        transactionId: item.transactionId,
        transactionType: item.transactionType,
        category: item.category,
        contributorProjectId: item.contributorProjectId,
        contributorEmail: item.contributorEmail || '-',
        country: item.country,
        payRate: item.payRate,
        hours: item.hours,
        units: item.units,
        transactionAmount:
          item.transactionAmount != null ? item.transactionAmount : null,
        transactionDate: item.transactionDate
          ? moment(item.transactionDate).format('YYYY-MM-DD')
          : 'N/A',
        createdDate: item.createdDate
          ? moment(item.createdDate).format('YYYY-MM-DD')
          : 'N/A',
        modifiedDate: item.modifiedDate
          ? moment(item.modifiedDate).format('YYYY-MM-DD')
          : 'N/A',
        transactionStatus: item.transactionStatus,
        statusVarient: getStatusType(item.transactionStatus),
        projectName: item.projectName || '-',
        projectObjectiveName: item.projectObjectiveName || '-',
        payoutCreatedDate: item.payoutCreatedDate
          ? moment(item.payoutCreatedDate).format('YYYY-MM-DD')
          : null,
        notes: item.notes,
        striked: striked,
        isLocked: isLocked,
      };
    });
    return map;
  };

  const parseValues = (value, name) => {
    if (!value) return { min: null, max: null };

    const number = value.match(/-?\d+(\.\d+)?/g).map(Number);
    let min = null;
    let max = null;
    if (number.length === 2) {
      min = number[0] || 0;
      max = number[1] || 0;
    } else {
      console.log('hi', number[0]);
      if (number[0] < 0) {
        max = number[0] || 0;
      } else {
        min = number[0] || 0;
      }
    }

    return { [`min_${name}`]: min, [`max_${name}`]: max };
  };

  const getPayload = (method) => {
    const {
      contributorEmail,
      contributorProjectId,
      country,
      project,
      transactionType,
      category,
      transactionDate,
      'transactionDate.customDates': customTransactionDate,
      transactionId,
      'invoicePeriod.month': month,
      'invoicePeriod.year': year,
      payRate,
      amount,
      transactionStatus,
      createdDate,
      'createdDate.customDates': customcreatedDate,
      lastModifiedDate,
      'lastModifiedDate.customDates': customlastModifiedDate,
      'notes.type': noteType,
      'notes.value': note,
      //sortOrder,
    } = filterValues;

    const { min_pay, max_pay } = parseValues(payRate, 'pay');
    const { min_amount, max_amount } = parseValues(amount, 'amount');

    const contains =
      note == undefined || note == null || note == ''
        ? null
        : noteType == undefined ||
            noteType == null ||
            noteType == '' ||
            noteType == 'Contains'
          ? true
          : false;

    let payload_map = {};
    if (method === 'post') {
      payload_map = {
        contributorEmail: contributorEmail ? contributorEmail?.split(',') : [],
        contributorProjectId: contributorProjectId
          ? contributorProjectId?.split(',')
          : [],
        country,
        project: project ? project.split(',') : [],
        month,
        category,
        transactionId: transactionId ? transactionId?.split(',') : [],
        transactionStatus,
      };
    } else {
      payload_map = {
        country: country?.filter((i) => i).join(';'),
        category: category?.filter((i) => i).toString(),
        month: month?.filter((i) => i).toString(),
        transactionStatus: transactionStatus?.filter((i) => i).toString(),
      };
    }

    let payload = {
      searchTerm: searchTerm,
      contributorEmail,
      contributorProjectId,
      project,
      transactionType,
      year,
      fixedRange: transactionDate,
      startDate: customTransactionDate?.[0],
      endDate: customTransactionDate?.[1],
      transactionId,
      fixedRangeForCreated: createdDate,
      createdStartDate: customcreatedDate?.[0],
      createdEndDate: customcreatedDate?.[1],
      fixedRangeForModified: lastModifiedDate,
      modifiedStartDate: customlastModifiedDate?.[0],
      modifiedEndDate: customlastModifiedDate?.[1],
      payRateLowerBound: min_pay && min_pay,
      payRateUpperBound: max_pay && max_pay,
      amountLowerBound: min_amount && min_amount,
      amountUpperBound: max_amount && max_amount,
      note,
      contains,
      [sortField.field]: sortField?.order,
      // sortOrder: sortOrder || 'Newest to oldest',
      ...payload_map,
      page: currentPage,
      size: pageSize,
    };

    Object.keys(payload).forEach((key) => {
      (payload[key] === null ||
        (payload[key] == [] && payload[key].length === 0) ||
        payload[key] === undefined) &&
        delete payload[key];
    });

    return payload;
  };

  const handleTransactions = (filters) => {
    setTableLoader(true);
    let payload = getPayload();
    payload = { ...payload, ...filters };

    getTranscations(payload)
      .then((data) => {
        if (data && !isEmpty(data)) {
          setTransactions((prev) => ({
            ...prev,
            [`${data.pagination.currentPage}`]: transformData(data),
          }));
          setTotalRecords(data?.pagination?.totalRows || 0);
        }
        setError(false);
      })
      .catch((error) => {
        setError(true);
        handleMessage('error', 'Unable to fetch transactions');
      })
      .finally(() => {
        setTableLoader(false);
        setPageLoader(false);
      });
  };

  const handleFirstCard = () => {
    return (
      <Layout
        style={{ backgroundColor: colors.colorBgLayout }}
        loading={cardsLoader}
        className="cardStyle"
      >
        <Row>
          <Col span={13}>
            <div style={{ padding: '24px 0px 0px 24px' }}>
              <Typography
                className="cards-header"
                style={{
                  float: 'left',
                }}
              >
                Total Transactions
              </Typography>
              {/* <MoreOutlined
                className="cards-header"
                style={{
                  float: 'right',
                  height: '35px',
                }}
              /> */}
            </div>
            {/* <div
              style={{
                height: '94px',
                display: 'inline-table',
                padding: '20px 0px 20px 37px',
              }}
            >
              <Typography className="cards-header">523</Typography>
              <Typography style={{ color: '#00000073' }}>
                Total records last 30 days
              </Typography>
            </div> */}
            {/* <Row style={{ height: '80px' }}>
              <Col span={12}>
                <div style={{ paddingLeft: '21px' }}>
                  <Typography className="card-footer">318</Typography>
                  <Typography className="card-lightFont">
                    Productivity
                  </Typography>
                </div>
              </Col>
              <Col span={1}>
                <Divider type="vertical" style={{ height: '44px' }} />
              </Col>
              <Col span={11}>
                <div style={{ paddingLeft: '16px' }}>
                  <Typography className="card-footer">205</Typography>
                  <Typography className="card-lightFont">Adjustment</Typography>
                </div>
              </Col>
            </Row> */}
          </Col>

          {/* <Col span={1}>
            <Divider type="vertical" style={{ height: '231px' }} />
          </Col>
          <Col span={10}>
            <div style={{ padding: '16px 12px', display: 'grid', gap: '12px' }}>
              <div>
                <Typography className="card-footer">116</Typography>
                <Typography className="card-lightFont">
                  Ready for Finance Review
                </Typography>
              </div>
              <div>
                <Typography className="card-footer">97</Typography>
                <Typography className="card-lightFont">
                  Ready for Invoice
                </Typography>
              </div>
              <div>
                <Typography className="card-footer">39</Typography>
                <Typography className="card-lightFont">
                  Under Further Review
                </Typography>
              </div>
              <Link to="" className="firstCard-link" underline={true}>
                View All Statuses
              </Link>
            </div>
          </Col> */}
        </Row>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            height: '70%',
            alignItems: 'center',
            fontSize: '16px',
            fontWeight: '700',
            color: 'grey',
          }}
        >
          Under development
        </div>
      </Layout>
    );
  };

  const handleSecondCard = () => {
    return (
      <Layout
        style={{ backgroundColor: colors.colorBgLayout }}
        loading={cardsLoader}
        className="cardStyle"
      >
        <div style={{ padding: '24px 0px 0px 24px' }}>
          <Typography
            className="cards-header"
            style={{
              float: 'left',
            }}
          >
            Total Transaction Value
          </Typography>
          {/* <MoreOutlined
            className="cards-header"
            style={{
              float: 'right',
              height: '35px',
            }}
          /> */}
        </div>

        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            height: '70%',
            alignItems: 'center',
            fontSize: '16px',
            fontWeight: '700',
            color: 'grey',
          }}
        >
          Under development
        </div>
        {/* <div
          style={{
            height: '94px',
            display: 'inline-table',
            padding: '20px 0px 20px 42px',
          }}
        >
          <Typography
            style={{
              fontWeight: '600',
              fontSize: '20px',
            }}
          >
            $152,621
          </Typography>
          <Typography style={{ color: '#00000073' }}>
            Total amount last 30 days
          </Typography>
        </div> */}
        {/* <Row style={{ height: '80px', padding: '0px 36px' }}>
          <Col span={12}>
            <div style={{ paddingLeft: '24px' }}>
              <Typography className="card-footer">318</Typography>
              <Typography className="card-lightFont ">Total Hours</Typography>
            </div>
          </Col>
          <Col span={1}>
            <Divider type="vertical" style={{ height: '44px' }} />
          </Col>
          <Col span={11}>
            <div style={{ paddingLeft: '16px' }}>
              <Typography className="card-footer">205</Typography>
              <Typography className="card-lightFont ">Total Units</Typography>
            </div>
          </Col>
        </Row> */}
      </Layout>
    );
  };

  const handleThirdCard = () => {
    return (
      <Layout
        style={{ backgroundColor: colors.colorBgLayout }}
        loading={cardsLoader}
        className="cardStyle"
      >
        <div style={{ padding: '24px 0px 0px 24px' }}>
          <Typography
            style={{
              fontWeight: '600',
              fontSize: '20px',
              float: 'left',
            }}
          >
            Modifications & Audit Metrics
          </Typography>
          {/* <MoreOutlined
            style={{
              float: 'right',
              color: 'black',
              fontWeight: '600',
              fontSize: '20px',
              height: '35px',
            }}
          /> */}
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            height: '70%',
            alignItems: 'center',
            fontSize: '16px',
            fontWeight: '700',
            color: 'grey',
          }}
        >
          Under development
        </div>
        {/* <div style={{ padding: '12px 24px' }}>
          <Row gutter={16} style={{ paddingBottom: '16px' }}>
            <Col span={8}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <Card
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 40,
                    height: 40,
                    borderRadius: 8,
                    backgroundColor: 'rgba(86, 202, 0, 0.1)', // Light green background
                    boxShadow: 'none',
                  }}
                >
                  <RiseOutlined style={{ color: '#56CA00', fontSize: 20 }} />
                </Card>

                <div>
                  <Typography className="card-footer">48</Typography>
                  <Typography className="card-lightFont">
                    Locked Transactions
                  </Typography>
                </div>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <Card
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 40,
                    height: 40,
                    borderRadius: 8,
                    backgroundColor: 'rgba(124, 77, 255, 0.1)',
                    boxShadow: 'none',
                  }}
                >
                  <UserOutlined style={{ color: '#9155FD', fontSize: 20 }} />
                </Card>

                <div>
                  <Typography className="card-footer">384</Typography>
                  <Typography className="card-lightFont">
                    Unlocked Transactions
                  </Typography>
                </div>
              </div>
            </Col>
            <Col span={8}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <Card
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 40,
                    height: 40,
                    borderRadius: 8,
                    backgroundColor: 'rgba(86, 202, 0, 0.1)', // Light green background
                    boxShadow: 'none',
                  }}
                >
                  <RiseOutlined style={{ color: '#56CA00', fontSize: 20 }} />
                </Card>

                <div>
                  <Typography className="card-footer">456</Typography>
                  <Typography className="card-lightFont">
                    Saved Modified Transactions
                  </Typography>
                </div>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <Card
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 40,
                    height: 40,
                    borderRadius: 8,
                    backgroundColor: 'rgba(124, 77, 255, 0.1)',
                    boxShadow: 'none',
                  }}
                >
                  <UserOutlined style={{ color: '#9155FD', fontSize: 20 }} />
                </Card>

                <div>
                  <Typography className="card-footer">35</Typography>
                  <Typography className="card-lightFont">
                    Draft Transactions
                  </Typography>
                </div>
              </div>
            </Col>
            <Col span={8}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <Card
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 40,
                    height: 40,
                    borderRadius: 8,
                    backgroundColor: 'rgba(86, 202, 0, 0.1)', // Light green background
                    boxShadow: 'none',
                  }}
                >
                  <RiseOutlined style={{ color: '#56CA00', fontSize: 20 }} />
                </Card>

                <div>
                  <Typography className="card-footer">20</Typography>
                  <Typography className="card-lightFont">
                    Voided Transactions
                  </Typography>
                </div>
              </div>
            </Col>
          </Row>
        </div> */}
      </Layout>
    );
  };

  const handleCreateInvoice = () => {
    setShowCreateInvoiceModal(false);
    setFullScreenLoader(true);
    createInvoice()
      .then((res) => {
        if (res.status === 200) {
          if (res?.data === LOCK_MSG) {
            handleMessage(
              'error',
              'System is Locked for any updates,Please try after some time',
            );
          } else {
            handleMessage(
              'success',
              'Invoice creation event triggered, Please check in batch jobs',
            );
          }
        } else {
          handleMessage('error', 'Failed to trigger create invoice event');
        }
      })
      .catch(() => {
        handleMessage('error', 'Failed to trigger create invoice event');
      })
      .finally(() => {
        setFullScreenLoader(false);
      });
  };

  const handleTransactionStatusUpdate = (type, rowId, status) => {
    setShowUpdateTransactionModal(false);
    setFullScreenLoader(true);

    let keys = [];
    let is_query = false;
    let filter = null;

    if (type === 'single') {
      keys = [rowId];
    } else if (type === 'selected') {
      keys = selectedRowKeys;
    } else if (type === 'query') {
      filter = getPayload('post');
      is_query = true;
    }

    updateTransactionStatus(keys, filter, status)
      .then((res) => {
        if (res === LOCK_MSG) {
          handleMessage(
            'error',
            'System is Locked for any updates,Please try after some time.',
          );
        } else {
          if (keys.length <= 10 && !is_query) {
            if (res?.failedTransactionIds?.length > 0) {
              handleMessage(
                'error',
                `Couldn't update ${res?.failedTransactionIds?.length} transactions`,
              );
            } else if (res?.successfulTransactions > 0) {
              handleMessage(
                'success',
                'Successfully updated transaction statuses',
              );
            }
          } else {
            handleMessage(
              'success',
              'Updating Status is in progress,Please check the batch updates.',
            );
          }
          handleApplyFilters();
        }
      })
      .catch(() => {
        handleMessage('error', 'Failed to update transaction statuses');
      })
      .finally(() => {
        setFullScreenLoader(false);
      });
  };

  const handleShowUploadModal = (type) => {
    setUploadModel({
      open: true,
      key: uploadModel.key + 1,
      type: type === 'Create New Transaction' ? 'Create' : 'Update',
      url:
        type === 'Create New Transaction'
          ? CREATE_NEW_TRANSACTION
          : UPLOAD_TRANS_BATCH_UPDATES,
    });
  };

  const handleDownloadTemplateAPI = async () => {
    setFullScreenLoader(true);
    try {
      const filter = getPayload();
      await getDownloadTemplate(filter);
      handleMessage(
        'success',
        'CSV file creation is in progress. Please check the batch jobs.',
      );
    } catch {
      handleMessage('error', 'Unable to download create transactions file');
    } finally {
      setFullScreenLoader(false);
    }
  };

  const handleSearch = (v) => {
    setSearchValue(v);
    if (v.length > 2) {
      setSearchLoader(true);
      let payout = getPayload();
      payout = { ...payout, searchTerm: v };
      getSearch(payout)
        .then((data) => {
          const options = data.map((d) => ({
            key: d,
            value: d,
          }));
          setSearchOptions(options);
        })
        .catch(() => {
          handleMessage('error', 'Unable to fetch Payouts');
        })
        .finally(() => {
          setSearchLoader(false);
        });
    } else {
      setSearchOptions([]);
    }
  };

  const handleSearchKey = (v) => {
    setSearchTerm(v || '');
    setSearchDropdown(false);
    const filters = {
      ...filterValues,
      searchTerm: v,
    };
    setFilterValues(filters);
    // handleInvoices({ searchTerm: v || '' });
    handleApplyFilters({ searchTerm: v || '' });
  };

  const CreateTransaction = () => {
    return (
      <CustomButton
        shape="round"
        icon={<PlusOutlined />}
        onClick={() => handleShowUploadModal('Create New Transaction')}
        disabled={pageLoader || isCreateDisable}
      >
        Create New Transaction
      </CustomButton>
    );
  };

  const CreateInvoice = () => {
    return (
      <CustomButton
        shape="round"
        variant="outlined"
        icon={<PlusOutlined />}
        disabled={tableLoader || isCreateInvoiceDisable}
        onClick={() => setShowCreateInvoiceModal(true)}
      >
        Create Invoice
      </CustomButton>
    );
  };

  const UpdateStatus = () => {
    return (
      <CustomButton
        shape="round"
        type="default"
        size="large"
        variant="outlined"
        icon={<ReloadOutlined />}
        disabled={tableLoader}
        onClick={() => setShowUpdateTransactionModal(true)}
      >
        Update Statuses
      </CustomButton>
    );
  };

  const ExportCsv = () => {
    return (
      <CustomButton
        shape="round"
        type="default"
        size="large"
        variant="outlined"
        icon={<ExportOutlined />}
        disabled={tableLoader}
        onClick={() => handleDownloadTemplateAPI()}
      >
        Export to CSV
      </CustomButton>
    );
  };

  const MoreActions = () => {
    return (
      <Dropdown
        menu={{
          items: dropdownIteam,
        }}
      >
        <CustomButton
          shape="round"
          variant="outlined"
          icon={<UploadOutlined />}
          disabled={pageLoader}
        >
          More
        </CustomButton>
      </Dropdown>
    );
  };

  const BatchJobs = (
    <CustomButton
      shape="round"
      variant="outlined"
      disabled={tableLoader}
      onClick={() => setIsAsyncTasksModalOpen(true)}
    >
      Batch Updates
    </CustomButton>
  );

  const dropdownIteam = [
    {
      label: (
        <a
          target="_blank"
          rel="noopener noreferrer"
          disabled={isUpdateDisable}
          onClick={() => handleShowUploadModal('Upload Batch Updates')}
        >
          <UploadOutlined style={{ padding: '10px' }} />
          Upload Batch Updates
        </a>
      ),
      key: '0',
    },
    {
      type: 'divider',
    },
    {
      disabled: true,
      label: (
        <a target="_blank" rel="noopener noreferrer" onClick={() => {}}>
          <UploadOutlined style={{ padding: '10px' }} />
          Download CSV Template
        </a>
      ),
      key: '1',
    },
  ];

  // const filterItems = [
  //   {
  //     label: (
  //       <a
  //         target="_blank"
  //         rel="noopener noreferrer"
  //         onClick={() => {
  //           const filters = {
  //             ...filterValues,
  //             sortOrder: 'Newest to oldest',
  //           };
  //           setFilterValues(filters);
  //           handleApplyFilters({
  //             sortOrder: 'Newest to oldest',
  //           });
  //         }}
  //       >
  //         Newest to oldest
  //       </a>
  //     ),
  //     key: '0',
  //   },
  //   {
  //     label: (
  //       <a
  //         target="_blank"
  //         rel="noopener noreferrer"
  //         onClick={() => {
  //           const filters = {
  //             ...filterValues,
  //             sortOrder: 'Oldest to newest',
  //           };
  //           setFilterValues(filters);
  //           handleApplyFilters({
  //             sortOrder: 'Oldest to newest',
  //           });
  //         }}
  //       >
  //         Oldest to newest
  //       </a>
  //     ),
  //     key: '1',
  //   },
  // ];

  const TableHeader = () => (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        margin: '-16px',
        padding: '16px',
        backgroundColor: colors.colorSplit,
      }}
    >
      <div
        style={{
          display: 'flex',
          gap: '16px',
        }}
      >
        <UpdateStatus />
        <ExportCsv />
      </div>
      <div
        style={{
          display: 'flex',
          gap: '16px',
          alignItems: 'center',
          margin: '-16px',
          padding: '16px',
        }}
      >
        <CustomButton
          shape="round"
          type="default"
          variant="outlined"
          icon={<FilterOutlined />}
          size="large"
          onClick={() => setOpenFilters(true)}
        >
          Filter
        </CustomButton>
        {/* <Dropdown
          menu={{
            items: filterItems,
          }}
          trigger={['click']}
        >
          <CustomButton
            type="default"
            variant="outlined"
            shape="round"
            icon={<SortAscendingOutlined />}
            size={'large'}
          >
            Sort
          </CustomButton>
        </Dropdown> */}
        <ConfigProvider
          theme={{
            token: {
              borderRadius: 100,
            },
          }}
        >
          <AutoComplete
            popupMatchSelectWidth={252}
            style={{
              width: 300,
            }}
            options={searchValue.length >= 3 && searchOptions}
            notFoundContent={
              (searchValue.length < 3 && 'Enter 3 letters for dropdown') ||
              (!searchLoader && searchOptions.length == 0 && 'No data found')
            }
            open={searchDropdown}
            onBlur={() => setSearchDropdown(false)}
            onSelect={(e) => {
              setSearchValue(e);
              setSearchDropdown(false);
            }}
            variant="borderless"
            size="large"
          >
            <div>
              <Input.Search
                size="large"
                value={searchValue}
                onSearch={handleSearchKey}
                onClear={handleSearchKey}
                onClick={() => setSearchDropdown(true)}
                allowClear
                placeholder="Search by transaction id"
                enterButton={
                  <Button
                    type="primary"
                    loading={searchLoader}
                    icon={<SearchOutlined />}
                  />
                }
                variant="borderless"
                onChange={(e) => handleSearch(e.target.value)}
                style={{
                  backgroundColor: colors.colorWhite,
                  borderRadius: 20,
                }}
              />
            </div>
          </AutoComplete>
        </ConfigProvider>
      </div>
    </div>
  );

  const handleApplyFilters = (filters) => {
    setOpenFilters(false);
    setTableId(() => tableId + 1);
    setSelectedRowKeys(() => {
      return [];
    });
    setTransactions(() => {
      return {};
    });
    setCurrentPage(() => {
      return 1;
    });
    handleTransactions(filters);
  };

  function handleApplysort(filters) {
    const updatedFilters = {
      ...filters,
      field: fields[filters.field] || filters.field,
    };

    setOpenFilters(false);
    setTableId(() => tableId + 1);
    setSelectedRowKeys(() => {
      return [];
    });
    setTransactions(() => {
      return {};
    });
    setCurrentPage(() => {
      return 1;
    });
    setSortField(() => {
      return updatedFilters;
    });
  }

  const handleRowSelection = (keys) => {
    setSelectedRowKeys(keys);
  };

  return (
    <>
      {/* {notificationContextHolder} */}
      {contextHolder}
      {pageLoader && (
        <Spin
          size="large"
          style={{
            display: 'flex',
            height: '100vh',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        />
      )}
      <Spin fullscreen={true} spinning={fullScreenLoader} />
      {/* {
        <>
          <Row gutter={16} style={{ padding: '16px' }}>
            <Col span={9}>{handleFirstCard()}</Col>
            <Col span={6}>{handleSecondCard()}</Col>
            <Col span={9}>{handleThirdCard()}</Col>
          </Row>
        </>
      } */}
      {!pageLoader && !error && (
        <>
          <div
            style={{
              display: 'flex',
              padding: '16px',
              justifyContent: 'space-between',
            }}
          >
            <div
              style={{
                display: 'flex',
                gap: '16px',
              }}
            >
              <CreateTransaction />
              <CreateInvoice />

              <MoreActions />
            </div>
            {/* <div>{BatchJobs}</div> */}
          </div>
          <TransactionsTable
            key={tableId}
            loading={tableLoader}
            transactions={currentData}
            TableHeader={TableHeader}
            handleSort={handleApplysort}
            sortField={sortField}
            handleRowSelection={handleRowSelection}
            selectedRowKeys={selectedRowKeys}
            handleRowStatusUpdate={handleTransactionStatusUpdate}
          />
          <Pagination
            style={{
              padding: '16px 0',
              display: 'flex',
              justifyContent: 'end',
            }}
            pageSize={pageSize}
            current={currentPage}
            total={totalRecords}
            showSizeChanger={true}
            onChange={handlePageChange}
            onShowSizeChange={handlePageSizeChange}
          />
        </>
      )}
      <FiltersPane
        openFilters={openFilters}
        filterValues={filterValues}
        setFilterValues={setFilterValues}
        setOpenFilters={setOpenFilters}
        handleApply={handleApplyFilters}
      />
      {!pageLoader && error && (
        <Result
          status="500"
          title="500"
          subTitle="Sorry, something went wrong."
        />
      )}

      <UploadFile
        key={uploadModel.key}
        visible={uploadModel.open}
        type={uploadModel.type}
        onClose={() => setUploadModel(false)}
        url={uploadModel.url}
      />
      <CreateInvoiceModal
        open={showCreateInvoiceModal}
        setOpen={setShowCreateInvoiceModal}
        onOk={handleCreateInvoice}
      />
      <UpdateTransactionModal
        open={showUpdateTransactionModal}
        setOpen={setShowUpdateTransactionModal}
        onOk={handleTransactionStatusUpdate}
        n={selectedRowKeys.length}
        count={totalRecords}
      />
      <AsyncTasksModal
        isOpen={isAsyncTasksModalOpen}
        onClose={() => setIsAsyncTasksModalOpen(false)}
      />
    </>
  );
};

export default Transactions;
